import React from "react"

import DashboardContainer from "../components/Dashboard/DashboardContainer"

function DashboardPage() {
  return <DashboardContainer />
}

export default DashboardPage
